// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(6192): All imports in import declaration are unused.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { css, jsx } from "@emotion/react";
import { PureComponent } from "react";

import Flex from "components/layout/Flex";
import {
  ComponentDefinition,
  ComponentTypeEnum,
  IButtonComponentDefinition,
  IButtonData,
  ICustomSectionDefinition,
  IHeaderComponentDefinition,
  ILabelComponentDefinition,
  ILinkComponentDefinition,
  ITitleComponentDefinition,
} from "services/custom-section";

import { Button, Header, Label, Line, Link, Title } from "./components";

interface IProps {
  section: ICustomSectionDefinition;
  onButtonClick?(buttonData: IButtonData): void;
  onLinkClick?(): void;
}

export class CustomSection extends PureComponent<IProps> {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private renderComponent = (component: ComponentDefinition, key: number) => {
    switch (component.type) {
      case ComponentTypeEnum.LabelValue: {
        const { data } = component as ILabelComponentDefinition;
        return (
          <Label
            label={data.label}
            value={data.value}
            inline={data.inline}
            imageUrl={data.imageUrl}
            onLinkClick={this.props.onLinkClick}
            key={key}
          />
        );
      }

      case ComponentTypeEnum.Title: {
        const { data } = component as ITitleComponentDefinition;
        return (
          <Title
            description={data.description}
            imgSize={data.imgSize}
            imgUrl={data.imgUrl || data.imageUrl}
            link={data.link}
            title={data.title}
            value={data.value}
            onLinkClick={this.props.onLinkClick}
            key={key}
          />
        );
      }

      case ComponentTypeEnum.Link: {
        const { data } = component as ILinkComponentDefinition;
        return (
          <Link url={data.url} value={data.value} inline={data.inline} onClick={this.props.onLinkClick} key={key} />
        );
      }

      case ComponentTypeEnum.Line:
        return <Line key={key} />;

      case ComponentTypeEnum.Button: {
        const { data } = component as IButtonComponentDefinition;
        return (
          <Button
            label={data.label}
            kind={data.buttonType}
            customId={data.id}
            openApp={data.openApp}
            onClick={this.props.onButtonClick}
            key={key}
          />
        );
      }

      case ComponentTypeEnum.Header: {
        const { data } = component as IHeaderComponentDefinition;
        return <Header name={data.name} link={data.link} imageUrl={data.imageUrl} key={key} />;
      }

      default:
        return null;
    }
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const { components = [] } = this.props.section;

    return (
      <Flex column gap="8px">
        {/* TODO: Fix this the next time the file is edited. */}
        {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
        {components.map((component: any, key: any) => (
          // FIXME: Fix this the next time the file is edited.
          // eslint-disable-next-line react/jsx-key
          <Flex alignItems="center">{this.renderComponent(component, key)}</Flex>
        ))}
      </Flex>
    );
  }
}
